import TokensImage from '../../modules/Forex/assets/tokens.svg';
// import PoolsImage from '../../modules/Forex/assets/'
import WrapsImage from '../../modules/Forex/assets/Group 521.svg';
import StocksImage from '../../modules/Forex/assets/Group 522.svg';
import CryptopairsImage from '../../modules/Forex/assets/Group 523.svg';
import DBTImage from '../../modules/Forex/assets/Group 527.svg';
import ProjectsImage from '../../modules/Forex/assets/Group 530.svg';
import NewsImage from '../../modules/Forex/assets/Group 528.svg';
import DelistedImage from '../../modules/Forex/assets/Group 529.svg';
import FxPairsImage from '../../modules/Forex/assets/Group 524.svg';

export const MenuData = [
  { label: 'SynthCryptos', path: '/', logo: TokensImage },
  { label: 'XMG Tokens', path: '/xmgtokens', logo: TokensImage },
  { label: 'EquiTrack', path: '/equitracktokens', logo: StocksImage },
  // Shown as "Hybrid" (formerly CryptoPairs). /cryptoPairs still routes here.
  { label: 'Hybrid', path: '/hybrid', logo: CryptopairsImage },
  { label: 'Wraps', path: '/wraptokens', logo: WrapsImage },
  // { label: 'PDCN', path: '/pdcn', logo: StocksImage },
  { label: 'DCN', path: '/dcn', logo: StocksImage },
  // { label: 'FxPairs', path: '/fxPairs', logo: FxPairsImage },
  { label: 'DBTs', path: '/dbt', logo: DBTImage },
  { label: 'VentureTokens', path: '/venturetoken', logo: ProjectsImage },
  // Shown as "Nexus" (formerly FanTokens). /FanTokens still routes here.
  { label: 'Nexus', path: '/nexus', logo: ProjectsImage },
  // { label: 'News', path: '/News', logo: NewsImage },
  { label: 'Delisted ', path: '/delistedtoken', logo: DelistedImage }
];
